import React, { useEffect, useState } from "react";
import ReturnOrderRequestColumn from "../ReturnOrderRequestColumn";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";

// Icon
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import ReturnOrderRequestRow from "../ReturnOrderRequestRow";

const ReturningReturnOrderRequest = ({
  dataLoading,
  allReturnOrderRequest,
}) => {
  const [rows, setRows] = useState(null);
  const [emptyRows, setEmptyRows] = useState(null);
  const [visibleRows, setVisibleRows] = useState(null);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (allReturnOrderRequest) {
      const myRows = [];
      allReturnOrderRequest.map((item) => {
        if (item.status === "Returning") {
          myRows.push(item);
        }
      });
      if (myRows.length) {
        setRows(myRows);
      }
    }
  }, [allReturnOrderRequest]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  useEffect(() => {
    if (rows) {
      setRowData({ myRows: rows });
    }
  }, [order, orderBy, page, rowsPerPage, rows]);

  const setRowData = ({ myRows }) => {
    const data = stableSort(myRows, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    setVisibleRows(data);

    const emptyRowsData =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - myRows.length) : 0;
    setEmptyRows(emptyRowsData);
  };

  return (
    <div className="all-return-order-request">
      <TableContainer>
        <Table aria-label="collapsible table" size={dense ? "small" : "medium"}>
          <ReturnOrderRequestColumn
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={visibleRows ? visibleRows.length : 0}
            dataLoading={dataLoading}
          />
          <TableBody>
            {visibleRows ? (
              visibleRows
                .slice(0)
                .reverse()
                .map((row) => <ReturnOrderRequestRow key={row._id} row={row} />)
            ) : (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * 5,
                }}
              >
                <TableCell colSpan={8}>
                  <div className="no-order-data">
                    <div className="content">
                      <DescriptionRoundedIcon className="icon" />
                      <p>{dataLoading ? "Loading..." : "No Data"}</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * emptyRows,
                }}
              >
                <TableCell colSpan={8} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={visibleRows ? visibleRows.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default ReturningReturnOrderRequest;
